import {analyticsClient} from '../../../analytics-client';

export function trackPhoneIntegrationOnboardCompleted(integrationType: string) {
    switch (integrationType) {
        case 'AIRCALL':
            analyticsClient.track(
                analyticsClient.EVENTS.TRACK_PHONE_INTEGRATION_ONBOARD_COMPLETED_AIRCALL
            );
            break;
        case 'CALLRAIL':
            analyticsClient.track(
                analyticsClient.EVENTS.TRACK_PHONE_INTEGRATION_ONBOARD_COMPLETED_CALLRAIL
            );
            break;
        case 'DIALPAD':
            analyticsClient.track(
                analyticsClient.EVENTS.TRACK_PHONE_INTEGRATION_ONBOARD_COMPLETED_DIALPAD
            );
            break;
        case 'RINGCENTRAL':
            analyticsClient.track(
                analyticsClient.EVENTS.TRACK_PHONE_INTEGRATION_ONBOARD_COMPLETED_RINGCENTRAL
            );
            break;
        case 'KIXIE':
            analyticsClient.track(
                analyticsClient.EVENTS.TRACK_PHONE_INTEGRATION_ONBOARD_COMPLETED_KIXIE
            );
            break;
        case 'CLICKTOCALL':
            analyticsClient.track(
                analyticsClient.EVENTS.TRACK_PHONE_INTEGRATION_ONBOARD_COMPLETED_CLICKTOCALL
            );
            break;
    }
}
